const showDashboard = {
	init() {
		// KvK opnieuw opvragen
		const stelUwVraagLink = document.querySelector('a#stelUwVraag');
		const uwVraagDiv = document.querySelector('div#uwVraag');
		if (stelUwVraagLink && uwVraagDiv) {
			stelUwVraagLink.addEventListener('click', function (event) {
				event.preventDefault();
				uwVraagDiv.classList.toggle('d-none');
			});
		}
	},
};

export default showDashboard;
